import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tree-li" }
const _hoisted_2 = { class: "acct-node" }
const _hoisted_3 = { class: "acct-body" }
const _hoisted_4 = { class: "acct-avatar-row" }
const _hoisted_5 = { class: "acct-ini" }
const _hoisted_6 = { class: "acct-title" }
const _hoisted_7 = { class: "acct-name" }
const _hoisted_8 = {
  key: 0,
  class: "acct-team-row"
}
const _hoisted_9 = {
  key: 1,
  class: "acct-resp"
}
const _hoisted_10 = {
  key: 0,
  class: "tree-ul"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accountability_chart_node = _resolveComponent("accountability-chart-node", true)!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "acct-accent" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.initials), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.roleTitle), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.node.Name), 1),
        (_ctx.node.Team)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(["pill", _ctx.teamColorClass])
              }, _toDisplayString(_ctx.node.Team), 3)
            ]))
          : _createCommentVNode("", true),
        (_ctx.accountabilities.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "acct-resp-label" }, "Roles and Responsibilities", -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountabilities, (a, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "acct-dot" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(a.value), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.accountabilities.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "acct-detail-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRoleCol()))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "Role Sheet", -1),
            _createElementVNode("span", { class: "acct-detail-arrow" }, "→", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.node.children && _ctx.node.children.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node.children, (c) => {
            return (_openBlock(), _createBlock(_component_accountability_chart_node, {
              key: c.EmployeeID,
              node: c
            }, null, 8, ["node"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}